import type { GemMeterState } from '@/modules/gem-meter/types/types';
import type { editor } from './editor/types';

import type { Store } from 'vuex';
import { createStore, useStore as baseUseStore } from 'vuex';

import modules from './modules';
import type { InjectionKey } from 'vue';

export type RootState = {
  editor: editor;
  gemMeter: GemMeterState;
};

const store = createStore({
  modules,
});

export default store;

const app = {
  $store: store,
};

export { app };

export const key: InjectionKey<Store<RootState>> = Symbol();
export function useStore<S = RootState>(): Store<any> {
  return store;
}
